import { render, staticRenderFns } from "./SearchHeaderWrapper.vue?vue&type=template&id=13d0d37e&"
import script from "./SearchHeaderWrapper.vue?vue&type=script&lang=js&"
export * from "./SearchHeaderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d0d37e')) {
      api.createRecord('13d0d37e', component.options)
    } else {
      api.reload('13d0d37e', component.options)
    }
    module.hot.accept("./SearchHeaderWrapper.vue?vue&type=template&id=13d0d37e&", function () {
      api.rerender('13d0d37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SearchHeaderWrapper.vue"
export default component.exports